import LogisticsCompany from "@/enum/LogisticsCompany";
import { get } from "@/services/http/backend";

interface AuthUrlResult {
  url: string;
}

/**
 * 获取今日头条授权url
 * @deprecated
 */
export async function getJRTTAuthUrl(isJinritemaiAuth = false) {
  const { authUrl } = await get<{ authUrl: string }>("/ewaybill/auth/jinritemai/url", {
    isJinritemaiAuth,
  });

  return { url: authUrl };
}

/**
 * 获取快手授权url
 *
 */
export async function getKWaiAuthUrl() {
  return get<AuthUrlResult>("/v2/ewaybill/auth/kwaishop/url");
}

/**
 * 获取小红书授权url
 *
 */
export async function getXHSAuthUrl() {
  return get<AuthUrlResult>("/v2/ewaybill/auth/xiaohongshu/url");
}

/**
 * 获取拼多多站外授权url
 * @deprecated
 */
export async function getPddAuthUrl() {
  const { authUrl } = await get<{ authUrl: string }>("/ewaybill/auth/pdd_auth/url");
  return { url: authUrl };
}

/**
 * 获取拼多多店铺授权url
 * @deprecated
 */
export async function getPddShopAuthUrl() {
  const { authUrl } = await get<{ authUrl: string }>("/ewaybill/auth/pdd_shop/url");
  return { url: authUrl };
}

/**
 * 构建获取京东物流云电子面单账号授权 URL
 */
export function getJDLAuthUrl(username: string, redirectUrl = "/ewaybillAccount") {
  return get<AuthUrlResult>("/v2/ewaybill/auth/jdl/url", {
    username,
    redirectUrl,
  });
}

/**
 * 构建获取京东无界电子面单账号授权 URL
 */
export function getJDWJAuthUrl(redirectUrl = "/ewaybillAccount") {
  return get<AuthUrlResult>("/v2/ewaybill/auth/jdwj/url", {
    redirectUrl,
  });
}

const JDWLLogisticsCompanies = [LogisticsCompany.JD_EXPRESS, LogisticsCompany.JDKY, LogisticsCompany.JD_HPCP];

export function isJDWLLogisticsCompany(logisticsCompany: LogisticsCompany) {
  return JDWLLogisticsCompanies.includes(logisticsCompany);
}

/**
 * 构建获取京东官方快递电子面单授权 URL
 */
export function getJDWLAuthUrl(username: string, logisticsCompany: LogisticsCompany, redirectUrl = "/ewaybillAccount") {
  return get<AuthUrlResult>("/v2/ewaybill/auth/jdwl/url", {
    logisticsCompany,
    username,
    redirectUrl,
  });
}

/**
 * 获取今日头条授权url
 */
export function getJRTTAuthUrlV2(redirectUrl = "/ewaybillAccount", isJinritemaiAuth = false) {
  return get<AuthUrlResult>("/v2/ewaybill/auth/jinritemai/url", {
    redirectUrl,
    isJinritemaiAuth,
  });
}

/**
 * 获取拼多多站外授权url
 */
export function getPddAuthUrlV2(redirectUrl = "/ewaybillAccount") {
  return get<AuthUrlResult>("/v2/ewaybill/auth/pdd/url", {
    isShop: false,
    redirectUrl,
  });
}

/**
 * 获取拼多多店铺授权url
 */
export function getPddShopAuthUrlV2(redirectUrl = "/ewaybillAccount") {
  return get<AuthUrlResult>("/v2/ewaybill/auth/pdd/url", {
    isShop: true,
    redirectUrl,
  });
}

/**
 * 获取淘宝菜鸟平台授权url
 */
export function getTaobaoAuthUrl(redirectUrl = "/ewaybillAccount") {
  return get<AuthUrlResult>("/v2/ewaybill/auth/taobao/url", {
    redirectUrl,
  });
}
